import { useAtomValue } from 'jotai';
import { createQuestionFromConfiguration } from '../../../logbook/views/QuestionView';
import {
    Card,
    Exercise,
    LabelBody,
    LabelBodyHeadline,
    LabelDisplay1,
    LabelDisplay2,
    LabelTelescope,
    SecondaryButton,
    Spacer,
    Textarea,
} from '../../components';
import { exercisesAtom } from '../../data';
import { IllustrationWeightLifter } from '../../icons';
import { ExerciseStatus } from '../../interfaces';
import { normalizeInput, useSyncedState } from '../../useSyncedState';
import { ExerciseData, ExerciseViewProps } from '../exercises';
import { page2SituationsToPracticeKey } from './Module2S1Exercise1';

const goalKey = 'exercise214GoalKey';

export const exerciseData21goal: ExerciseData = {
    ExerciseView: Module2S1ExerciseGoal,
    dataKeys: [goalKey],
    questions: [
        createQuestionFromConfiguration({
            dataKeys: [goalKey],
            title: 'Skriv din målsætning',
            description:
                'Lav en konkret aftale med dig selv om, hvornår du vil øve dig.',
        }),
    ],
};

export function Module2S1ExerciseGoal({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    const exercises = useAtomValue(exercisesAtom);
    const [goalInput, setGoalInput] = useSyncedState(
        exercise.Data[goalKey] ?? '',
    );
    const situationsToPracticeInput = exercises.find((x) => x.Code == '2.1.1')
        ?.Data[page2SituationsToPracticeKey];

    return (
        <Exercise title="Målsætning">
            <LabelDisplay2>Sæt dig et mål</LabelDisplay2>
            <LabelBody class="my-10">
                Du kan øve dig i at være i nuet ved at lave en øvelse flere
                gange.
            </LabelBody>
            <LabelBody>
                Vælg en eller flere af øvelserne, og prøv at lave en konkret
                aftale med dig selv om, hvornår du vil øve dig.
            </LabelBody>
            <IllustrationWeightLifter className="mx-auto my-30" />
            <Card>
                <LabelDisplay1>Skriv din målsætning</LabelDisplay1>
                <LabelBody class="mt-10">
                    Når du skal vælge et konkret tidspunkt, der passer for dig,
                    kan du både tænke på hverdagssituationer eller på de
                    situationer, du tidligere har nævnt i øvelsen “Kortlæg dit
                    nærvær”.{' '}
                    {situationsToPracticeInput &&
                        'Som en hjælp til at huske det, kan du se, hvad du skrev herunder.'}
                </LabelBody>
                {situationsToPracticeInput && (
                    <>
                        <LabelBodyHeadline
                            color="text-dark-red"
                            class="mb-10 mt-30"
                        >
                            Dit svar fra kortlæg dit nærvær
                        </LabelBodyHeadline>
                        <LabelTelescope class="whitespace-pre-wrap">
                            {situationsToPracticeInput}
                        </LabelTelescope>
                    </>
                )}
                <Textarea text={goalInput} onChangeText={setGoalInput} />
                <LabelBody>
                    Dit svar bliver gemt i logbogen, når du fortsætter.
                </LabelBody>
            </Card>
            <Spacer class="mt-30" />
            <SecondaryButton
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                        data: {
                            [goalKey]: normalizeInput(goalInput),
                        },
                    })
                }
            >
                Gem i logbogen
            </SecondaryButton>
        </Exercise>
    );
}
